module.exports = __webpack_public_path__ + "img/card-end-term.20c2b4b0.svg";